import React from 'react';
import {mealScenes} from '../data/breads';
import MealArtwork from './MealArtwork';
import SectionIntro from './SectionIntro';

function BreadInUse() {
  return (
    <section className="bread-in-use" aria-labelledby="use-title">
      <SectionIntro label="BRØD I BRUG" title="SKABT TIL MÅLTIDER, IKKE BARE TIL HYLDEN">
        <p id="use-title">
          South Eastern Bakery skal vise brødene dér, hvor de får betydning: som en del af et
          godt måltid. Derfor tager det visuelle univers udgangspunkt i serveringer, anvendelse
          og inspiration frem for traditionelle produktbilleder.
        </p>
      </SectionIntro>
      <div className="meal-grid">
        {mealScenes.map((scene, index) => (
          <figure className="meal-scene" key={scene.title}>
            <MealArtwork variant={scene.variant} image={scene.image} />
            <figcaption>
              <span className="scene-number">0{index + 1}</span>
              <strong>{scene.title}</strong>
              <small>Visuel inspiration · Ikke endelige produkter</small>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}

export default BreadInUse;